export default "__VITE_ASSET__CRsCfgpp__"